<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fas fa-robot">
            <fluxo></fluxo>
        </c-panel>
    </div>
</template>
<script>
import fluxo from "./fluxo"
export default {
    components: { fluxo },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Assistente Virtual' }
}
</script>
